import React, { FunctionComponent } from 'react';
import BaseTransferOption from '../baseOption/BaseTransferOption';
import { Box, Typography } from '@material-ui/core';
import ITransferGroup from '../../../model/ITransferGroup';
import transferGroupStyles from './transferGroupStyles';
import Translation from '../../../../common/components/translation/Translation';

export interface ITransferGroupProps {
  currentModel: string;
  transferGroups: ITransferGroup[];
}

const TransferGroup: FunctionComponent<ITransferGroupProps> = ({ currentModel, transferGroups }) => {
  const styles = transferGroupStyles();

  return (
    <>
      {transferGroups.map(transferGroup => {
        if (!transferGroup || !transferGroup.transferOptions.length) {
          return null;
        }

        return (
          <Box key={transferGroup.name} data-test={`stock:transfer:${transferGroup.name}`}>
            <Typography className={styles.action}>
              <Translation
                id={`trans__configurator__stock__transfer_modal_${transferGroup.name}`}
                values={{ value: currentModel }}
              />
            </Typography>
            {transferGroup.transferOptions.map(transferOption => (
              <BaseTransferOption
                key={transferOption.type}
                type={transferOption.type}
                options={transferOption.options}
              />
            ))}
          </Box>
        );
      })}
    </>
  );
};

export default TransferGroup;
